import { render, staticRenderFns } from "./gerarContrato.vue?vue&type=template&id=6427b8d2&scoped=true"
import script from "./gerarContrato.vue?vue&type=script&lang=js"
export * from "./gerarContrato.vue?vue&type=script&lang=js"
import style0 from "./gerarContrato.vue?vue&type=style&index=0&id=6427b8d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6427b8d2",
  null
  
)

export default component.exports